<h2 mat-dialog-title class="mb-3 dialog-title">Create Common Item</h2>

<div class="dialog-header-fixed">
    <div class="input-row" [formGroup]="classForm">
<!--        <mat-form-field appearance="outline" class="me-3">-->
<!--            <mat-label>Effective Date</mat-label>-->
<!--            <input matInput [matDatepicker]="picker" [value]="effectiveDate" (dateChange)="onDateChange($event)">-->
<!--            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>-->
<!--            <mat-datepicker #picker></mat-datepicker>-->
<!--        </mat-form-field>-->
        <mat-form-field appearance="outline" floatLabel="always" class="header-select">
            <mat-label>Class</mat-label>
            <mat-select formControlName="class" (selectionChange)="buildForm()">
                <mat-option value="ITEM_GROUPING">Item Group</mat-option>
                <mat-option value="ITEM">Item</mat-option>
                <mat-option value="MODIFIER_GROUPING">Modifier Group</mat-option>
                <mat-option value="MODIFIER">Modifier</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>

<mat-dialog-content class="dialog-content">
        <mat-card class="form-card">
            <mat-tab-group>
                <mat-tab label="Class Attributes">
                    <form [formGroup]="form" *ngIf="formReady" class="form-grid">
                        <div *ngFor="let formField of classAttributes" class="form-field-wrapper">
                            <label class="grid-label">
                                {{ formField.name }}
                                <span style="color: red; position: relative; top: 3px;"
                                      *ngIf="formField.required">*</span>
                            </label>
                            <div class="form-field-input">
                                <div *ngIf="formField.type === 'TEXT'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <input matInput [formControlName]="formField.jsonProperty" [type]="'text'" class="flex-100">
                                        <mat-error *ngIf="form.get(formField.jsonProperty)?.hasError('required')">
                                            {{ formField.name }} is required
                                        </mat-error>
                                        <mat-error *ngIf="form.get(formField.jsonProperty)?.hasError('whitespace')">
                                            {{ formField.name }} cannot be empty or contain only spaces
                                        </mat-error>
                                        <mat-error *ngIf="form.get(formField.jsonProperty)?.hasError('tagFormat')">
                                            {{ formField.name }} must only contain uppercase letters, numbers, and underscores
                                        </mat-error>
                                        <!--                                       (focusout)="formField.tag === 'TAG' ? findTagExists() : null"-->
                                    </mat-form-field>
                                </div>
                                <div *ngIf="formField.type === 'NUM'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <input matInput [formControlName]="formField.jsonProperty" [type]="'number'" class="flex-100">
                                        <!--                                       (focusout)="numberValidation(formField.jsonProperty)"-->
                                    </mat-form-field>
                                </div>
                                <div *ngIf="formField.type === 'BOOL'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <mat-select [formControlName]="formField.jsonProperty" class="flex-100" [compareWith]="compareBoolValues">
                                            <mat-select-trigger>
                                                {{ getBoolDisplayText(formField.jsonProperty) }}
                                            </mat-select-trigger>
                                            <mat-option *ngFor="let option of formField.options"
                                                        [value]="option?.value ?? option">
                                                {{ option?.label ?? option }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div *ngIf="formField.type === 'TEXTAREA'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                <textarea matInput
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="3"
                          [formControlName]="formField.jsonProperty" class="flex-100">
                </textarea>
                                        <mat-error *ngIf="form.get(formField.jsonProperty)?.hasError('required')">
                                            {{ formField.name }} is required
                                        </mat-error>
                                        <mat-error *ngIf="form.get(formField.jsonProperty)?.hasError('whitespace')">
                                            {{ formField.name }} cannot be empty or contain only spaces
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div *ngIf="formField.type === 'SELECT'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <mat-select [formControlName]="formField.jsonProperty" class="flex-100">
                                            <mat-option *ngFor="let option of formField.options"
                                                        [value]="option.value ?? option.tag">{{ option.label ?? option.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div *ngIf="formField.type === 'MULTI_SELECT'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <mat-select [formControlName]="formField.jsonProperty"
                                                    multiple class="flex-100">
                                            <mat-option *ngFor="let option of formField.options as Array"
                                                        [value]="option.value">{{ option.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div *ngIf="formField.type === 'IMAGE'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <input matInput [formControlName]="formField.jsonProperty" [type]="'text'" class="flex-100">
                                        <!--                                       (focusout)="imageValidation(formField.jsonProperty)"-->
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </mat-tab>
                <mat-tab label="Required Global Attributes">
                    <form [formGroup]="form" *ngIf="formReady" class="form-grid">
                        <div *ngFor="let formField of getRequiredGlobalAttributes()" class="form-field-wrapper">
                            <label [matTooltip]="formField.description" class="grid-label">
                                {{ formField.name }}
                                <span style="color: red; position: relative; top: 3px;"
                                      *ngIf="formField.required">*</span>
                            </label>
                            <div class="form-field-input">
                                <div *ngIf="formField.type === 'TEXT'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <input matInput [formControlName]="formField.jsonProperty" [type]="'text'" class="flex-100">
                                        <mat-error *ngIf="form.get(formField.jsonProperty)?.hasError('required')">
                                            {{ formField.name }} is required
                                        </mat-error>
                                        <mat-error *ngIf="form.get(formField.jsonProperty)?.hasError('whitespace')">
                                            {{ formField.name }} cannot be empty or contain only spaces
                                        </mat-error>
                                        <mat-error *ngIf="form.get(formField.jsonProperty)?.hasError('tagFormat')">
                                            {{ formField.name }} must only contain uppercase letters, numbers, and underscores
                                        </mat-error>
                                        <!--                                       (focusout)="formField.tag === 'TAG' ? findTagExists() : null"-->
                                    </mat-form-field>
                                </div>

                                <div *ngIf="formField.type === 'NUM'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <input matInput [formControlName]="formField.jsonProperty" [type]="'number'" class="flex-100">
                                        <!--                                       (focusout)="numberValidation(formField.jsonProperty)"-->
                                    </mat-form-field>
                                </div>

                                <div *ngIf="formField.type === 'BOOL'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <mat-select [formControlName]="formField.jsonProperty" class="flex-100" [compareWith]="compareBoolValues">
                                            <mat-select-trigger>
                                                {{ getBoolDisplayText(formField.jsonProperty) }}
                                            </mat-select-trigger>
                                            <mat-option *ngFor="let option of formField.options"
                                                        [value]="option?.value ?? option">
                                                {{ option?.label ?? option }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div *ngIf="formField.type === 'TEXTAREA'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                <textarea matInput
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="3"
                          [formControlName]="formField.jsonProperty" class="flex-100">
                </textarea>
                                        <mat-error *ngIf="form.get(formField.jsonProperty)?.hasError('required')">
                                            {{ formField.name }} is required
                                        </mat-error>
                                        <mat-error *ngIf="form.get(formField.jsonProperty)?.hasError('whitespace')">
                                            {{ formField.name }} cannot be empty or contain only spaces
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div *ngIf="formField.type === 'SELECT'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <mat-select [formControlName]="formField.jsonProperty" class="flex-100">
                                            <mat-option *ngFor="let option of formField.options"
                                                        [value]="option.value ?? option.tag">{{ option.label ?? option.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div *ngIf="formField.type === 'MULTI_SELECT'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <mat-select [formControlName]="formField.jsonProperty"
                                                    multiple class="flex-100">
                                            <mat-option *ngFor="let option of formField.options as Array"
                                                        [value]="option.value">{{ option.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div *ngIf="formField.type === 'IMAGE'">
                                    <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                        <input matInput [formControlName]="formField.jsonProperty" [type]="'text'" class="flex-100">
                                        <!--                                       (focusout)="imageValidation(formField.jsonProperty)"-->
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions-fixed">
    <button mat-raised-button color="primary" type="button" mat-dialog-close (click)="close()">
        Cancel
    </button>

    <button mat-raised-button color="primary" type="submit" [disabled]="form?.invalid || form?.pristine"
            (click)="save()">
        <mat-icon aria-hidden="true">save</mat-icon>
        Save
    </button>
</mat-dialog-actions>
